module.exports = __webpack_public_path__ + "static/hero-crm-5ef3cd43c6e5f80f62c3bf4dfd08f34a.svg";